import { Info } from "lucide-react";

const InfoCard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="border-state-info flex overflow-hidden rounded-md border">
      <div className="bg-bg-info-1 flex flex-col items-center justify-start px-2 py-4 md:justify-center md:p-4">
        <Info className="text-state-info size-6 md:size-8" />
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
};

export default InfoCard;
